import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Breadcrumb, Avatar, Tag } from 'antd';
import { makeStyles, MenuItem } from '@material-ui/core';
import { fetchAllComplains, updateComplainAction } from '../../../actions/complainsAction';
import ArrowNextIcon from '../../../asset/arrow-next.svg';
import CButton from '../../../component/Button';
import formatDate from '../../../helpers/formatDate';
import Loader from '../../../component/Loader/Loader';
import { DefaultSelect } from '../../../component/Select';
import Modal from '../../../component/Modal/Modal';

const useStyles = makeStyles({
  gridContainer: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 33%',
    marginLeft: '90px',
    marginTop: '55px'
  },
  gridHeader: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 33%',
    justifyContent: 'space-between',
    marginLeft: '90px',
    textAlign: 'start',
    width: '100%'
  },
  gridItem: {
    maxWidth: '90%',
    textAlign: 'start',
    wordWrap: 'break-word'
  },
  gridItemPayment: {
    '& div': {
      marginBottom: '20px'
    },
    gridColumn: '1',
    gridRow: 'span 2',
    height: '100%',
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemPayment1: {
    gridColumn: 'span 2',
    gridRow: 'span 1',
    height: '100%',
    maxWidth: '90%',
    textAlign: 'start'
  },
  imageStyle: {
    borderRadius: '50%',
    display: 'flex',
    height: '55px',
    left: '-68px',
    position: 'absolute',
    width: '55px'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    marginTop: '5px'
  },
  selectHeader: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    margin: '0px'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  },
  tagStyle: {
    backgroundColor: 'rgba(65, 204, 156, 0.15)',
    border: 'none',
    borderRadius: '6px',
    color: '#41CC9C',
    fontSize: '16px',
    padding: '12px 15px'
  },
  usersInfo: {
    display: 'flex'
  }
});

const ComplainsDetail = () => {
  const { complainId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);
  const [blockReason, setBlockReason] = useState('Reason');
  const [blockId, setBlockId] = useState('');
  const reasons = ['Offensive content', 'Taken From Web', 'Fake Item'];
  const currentProject = useSelector(({ project }) => project.currentProject);
  const complains = useSelector(({ complains }) => complains.complains);
  const selectedItem = complains.find((item) => item._id === complainId);
  const selectedCustomer = complains.find((item) => item._id === blockId);

  const onCancel = () => {
    setShowModal(false);
    setBlockReason('');
  };

  const onComplainBlock = () => {
    if (selectedCustomer.status) {
      selectedCustomer.status = 'blocked';
      selectedCustomer.reason = blockReason;
    } else {
      selectedCustomer.status = 'blocked';
      selectedCustomer.reason = blockReason;
    }

    dispatch(
      updateComplainAction(currentProject._id, blockId, selectedCustomer, () => {
        dispatch(fetchAllComplains());
      })
    );
    setShowModal(false);
    onCancel();
  };

  const onComplainCloseCase = () => {
    if (selectedCustomer.status) {
      selectedCustomer.status = 'resolved';
    } else {
      selectedCustomer.status = 'resolved';
    }

    dispatch(
      updateComplainAction(currentProject._id, blockId, selectedCustomer, () => {
        dispatch(fetchAllComplains());
      })
    );

    setShowModal(false);
    onCancel();
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchAllComplains());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  function itemRender(route, params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;
    setBlockId(route.breadcrumbName);

    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <span onClick={() => history.goBack()} style={{ cursor: 'pointer' }}>
        {route.breadcrumbName}
      </span>
    );
  }

  const routes = [
    {
      breadcrumbName: 'Complains',
      path: '/authentication/complains'
    },
    {
      breadcrumbName: complainId || '-',
      path: `/authentication/complains/${complainId}`
    }
  ];

  const ComplainHeader = () => {
    const finalDate = formatDate(selectedItem?.createdAt) || '-';
    const status = selectedItem?.status === 'inReview' ? 'Open' : selectedItem?.status || '-';
    const type = selectedItem?.type || '-';

    const tagSwitch = () => {
      switch (status) {
        case 'untouched':
          return (
            <Tag
              className={classes.tagStyle}
              style={{
                backgroundColor: 'rgba(85, 100, 248, 0.15)',
                color: '#5564F8'
              }}
            >
              {status}
            </Tag>
          );
        case 'blocked':
          return (
            <Tag
              className={classes.tagStyle}
              style={{
                backgroundColor: 'rgba(255, 71, 108, 0.15)',
                color: '#FF476C'
              }}
            >
              {status}
            </Tag>
          );
        default:
          return (
            <Tag
              className={classes.tagStyle}
              style={{
                backgroundColor: 'rgba(65, 204, 156, 0.15)',
                color: '#41CC9C'
              }}
            >
              {status}
            </Tag>
          );
      }
    };

    return (
      <div
        style={{
          display: 'flex',
          width: '100%'
        }}
      >
        <div className={classes.gridHeader}>
          <div className={classes.gridItem} style={{ position: 'relative' }}>
            <Avatar
              className={classes.imageStyle}
              src={
                type === 'user'
                  ? selectedItem?.user?.profilePictureUrl
                  : selectedItem?.item?.imageUrl
              }
              style={type === 'user' ? { borderRadius: '50%' } : { borderRadius: '12px' }}
            />
            <span className={classes.span}>
              {type === 'user' ? selectedItem?.user?.userName : selectedItem?.item?.title || '-'}
            </span>
            <p className={classes.p}>
              ID:{' '}
              <span style={{ color: 'black' }}>
                {type === 'user' ? selectedItem?.user?.userId : selectedItem?.item?._id || '-'}
              </span>
            </p>
          </div>
          <div className={classes.gridItem}>
            <span className={classes.span}>{finalDate || '-'}</span>
            <p className={classes.p}>Date & Time</p>
          </div>
          <div className={classes.gridItem}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                maxWidth: '100%'
              }}
            >
              {tagSwitch()}
              <CButton onClick={() => setShowModal(true)} type="secondary">
                {type === 'user' ? 'Block Customer' : 'Block Item'}
              </CButton>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ComplainBody = () => {
    const userName = `@${selectedItem?.reporter.userName}`;

    return (
      <div className={classes.gridContainer}>
        <div className={classes.gridItemPayment}>
          <div className={classes.gridItem}>
            <p className={classes.p}>Reported By</p>
            <div className={classes.usersInfo}>
              <div style={{ marginRight: '10px', width: '50px' }}>
                <Avatar
                  src={selectedItem?.reporter.profilePictureUrl}
                  style={{
                    display: 'flex',
                    height: '50px',
                    marginRight: '8px',
                    width: '50px'
                  }}
                />
              </div>
              <div className={classes.gridItem}>
                <span className={classes.span}>{userName || '-'}</span>
                <p className={classes.p}>ID: {selectedItem?.reporterId || '-'}</p>
              </div>
            </div>
          </div>
          <div
            className={classes.gridItem}
            style={selectedItem?.type === 'user' ? { display: 'none' } : { display: 'block' }}
          >
            <p className={classes.p}>Seller</p>
            <div className={classes.usersInfo}>
              <div style={{ marginRight: '10px', width: '50px' }}>
                <Avatar
                  style={{
                    display: 'flex',
                    height: '50px',
                    marginRight: '8px',
                    width: '50px'
                  }}
                />
              </div>
              <div className={classes.gridItem}>
                <span className={classes.span}>-</span>
                <p className={classes.p}>ID:-</p>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridItemPayment1}>
          <div className={classes.gridItem} style={{ paddingLeft: '10px' }}>
            <p className={classes.p}>Reason</p>
            {selectedItem?.reason || '-'}
          </div>
        </div>
      </div>
    );
  };

  const isLoaded = useSelector(({ complains }) => complains.isLoaded);

  if (!isLoaded) {
    return <Loader />;
  }

  return (
    <Layout style={{ background: 'white' }}>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            justifyContent: 'flex-start'
          }}
        />
        <CButton onClick={onComplainCloseCase} type="primary">
          Close Case
        </CButton>
      </div>
      <div style={{ marginTop: '55px', padding: '0px 40px 0px 35px' }}>
        <ComplainHeader />
        <ComplainBody />
      </div>
      <Modal
        footerActions={
          <>
            <CButton onClick={onCancel} type="secondary" xstyle={{ height: '40px' }}>
              Cancel
            </CButton>
            <CButton onClick={onComplainBlock} type="primary" xstyle={{ height: '40px' }}>
              Block
            </CButton>
          </>
        }
        handleClose={onCancel}
        isModalOpen={showModal}
        styles={{
          '& .MuiDialogContent-root': {
            paddingBottom: '24px'
          },
          width: '400px'
        }}
        titleContent={<span className="modal-title">Select a Reason</span>}
      >
        <DefaultSelect onSelect={(reason) => setBlockReason(reason)} value={blockReason}>
          <MenuItem value="Reason">Reason</MenuItem>
          {reasons.map((reason) => (
            <MenuItem key={reason} value={reason}>
              {reason}
            </MenuItem>
          ))}
        </DefaultSelect>
      </Modal>
    </Layout>
  );
};

export default ComplainsDetail;
